export default __webpack_public_path__ + "static/media/prestige-card.edae32ea.png";